import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {ChevronUpIcon} from "../../../../assets/svg/chevron-up.icon";
import {ChevronDownIcon} from "../../../../assets/svg/chevron-down.icon";
import {IDropDownController} from "../../drop-down-controller.interface";

export const DropDownIndicatorContainerBox = styled.div`
`

interface DropDownIndicatorComponentProps {
    isOpen: boolean;
    dropDownController: IDropDownController;
}

export const DropDownIndicatorComponent: React.FC<DropDownIndicatorComponentProps> = observer((props) => {
    const renderIcon = () => {
        if(props.isOpen) {
            return (<ChevronUpIcon/>);
        } else {
            return (<ChevronDownIcon/>)
        }
    }

    const onDropDownIndicatorClick = () => {
        if(props.isOpen) {
            props.dropDownController.closeDropDown();
        } else {
            props.dropDownController.openDropDown();
        }
    }

    return (
        <DropDownIndicatorContainerBox onClick={onDropDownIndicatorClick}>
            {renderIcon()}
        </DropDownIndicatorContainerBox>
    )
});
